import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, ButtonToolbar } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { css } from 'glamor';
import BaseLoader from '../../../_Common/BaseLoader';
import CosAnnexeForm from './CosAnnexeForm';

const styles = {
  buttonPanel: css({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '0px',
    marginBottom: '0px',
    marginRight: '17px',
    marginLeft: '17px',
  }),
};

const CosAnnexeFormModal = props => {
  const { cosAnnexeId, title } = props;
  return (
    <div>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <BaseLoader isLoading={props.isLoading}>
          <CosAnnexeForm cosAnnexeId={cosAnnexeId} />
        </BaseLoader>
      </Modal.Body>
      <Modal.Footer>
        <div className={styles.buttonPanel}>
          <ButtonToolbar>
            <Button bsSize="small" bsStyle="danger" type="button" onClick={props.closeModal}>
              <i className="fa fa-times" />&nbsp;
              <Translate value="general.close" />
            </Button>
            <Button
              bsSize="small"
              bsStyle="success"
              type="button"
              onClick={props.onSaveButtonClick}
              disabled={props.isFormInValid || props.isFormPristine}>
              <Translate value="general.save" />&nbsp;
              <i className="fa fa-arrow-circle-right" />
            </Button>
          </ButtonToolbar>
        </div>
      </Modal.Footer>
    </div>
  );
};

CosAnnexeFormModal.defaultProps = {
  cosAnnexeId: '',
};

CosAnnexeFormModal.propTypes = {
  onSaveButtonClick: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  cosAnnexeId: PropTypes.number,
  isLoading: PropTypes.bool.isRequired,
  isFormInValid: PropTypes.bool.isRequired,
  isFormPristine: PropTypes.bool.isRequired,
};

export default CosAnnexeFormModal;
